import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth verloopt via httpOnly cookies — nooit tokens in JS/localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Verplichte 2FA (na livegang): zonder 2FA-sessie stuurt de server 403; dan naar de beveiligingspagina.
api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 403 && /Tweestapsverificatie/.test(err.response.data?.detail || "") && !window.location.pathname.startsWith("/admin/security")) {
    window.location.assign("/admin/security?verplicht=1");
  }
  return Promise.reject(err);
});

// Paginagegevens die de prerender in de HTML meegeeft, zodat de eerste weergave direct gevuld is (geen verspringing).
const SNAPSHOT = (() => {
  try { return JSON.parse(document.getElementById("mk-api-snapshot")?.textContent || "{}"); } catch { return {}; }
})();
export const snapshotData = (url) => (url ? SNAPSHOT[url] : undefined);

// Resolve a stored image path (e.g. "kozijnexpert/public/abc.jpg") to a public URL.
// Pass-through for absolute URLs (http(s)://, data:, blob:) and root-relative paths.
export const imageUrl = (path) => {
  if (!path) return "";
  if (/^(https?:)?\/\//i.test(path) || path.startsWith("data:") || path.startsWith("blob:") || path.startsWith("/")) {
    return path;
  }
  return `${API}/public-files/${path}`;
};

// Sessievlag (niet-gevoelig): het echte JWT zit in een httpOnly cookie.
// De vlag stuurt alleen de client-side redirects; de server handhaaft de beveiliging.
export const setAuthToken = (loggedIn) => {
  if (loggedIn) {
    localStorage.setItem("kozijn_admin_session", "1");
  } else {
    localStorage.removeItem("kozijn_admin_session");
    api.post("/auth/logout").catch(() => {});
  }
};

export const trackEvent = (name, payload = {}) => {
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
      if (typeof window.gtag === "function" && window.__ga4_loaded) {
        window.gtag("event", name, payload);
      }
    }
  } catch (e) {
    if (typeof console !== "undefined") console.warn("trackEvent failed:", e);
  }
};

// First-touch attributie (alleen wat de bezoeker zelf meebrengt; geen persoonsgegevens).
const UTM_KEYS = { utm_source: "source", utm_medium: "medium", utm_campaign: "campaign", utm_content: "content", utm_term: "term", gclid: "gclid", fbclid: "fbclid" };
export const captureAttribution = () => {
  try {
    if (sessionStorage.getItem("mk_attr")) return;
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    Object.entries(UTM_KEYS).forEach(([k, v]) => { const val = params.get(k); if (val) utm[v] = val.slice(0, 200); });
    const ref = document.referrer && !document.referrer.includes(window.location.hostname) ? document.referrer : "";
    sessionStorage.setItem("mk_attr", JSON.stringify({ utm, referrer: ref.slice(0, 500), landing_page: window.location.pathname }));
  } catch (err) {
    console.warn("Attributie vastleggen mislukt:", err);
  }
};
export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem("mk_attr") || "{}"); } catch { return {}; }
};
